<template>
	<GmapCustomMarker
		:marker="{
			lat: plantioMarker.infoPoligono.centroId.coordinates[1],
			lng: plantioMarker.infoPoligono.centroId.coordinates[0],
		}"
		:z-index="zIndex"
		@mouseenter.native="zIndex = 60"
		@mouseleave.native="zIndex = 50"
	>
		<div class="container__plantiomarker">
			<div class="container__plantiomarker__close">
				{{ plantioMarker.codigo }}
			</div>
			<div class="container__plantiomarker__open">
				<div class="container__plantiomarker__open__title">
					<span>{{ plantioMarker.codigo }}</span>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('areaDoPlantio') }}</span>
						<span>
							{{ plantioMarker.area }} (ha)
							<span>/ {{ plantioMarker.areaDoTalhao }} (ha)</span>
						</span>
						<span>
							{{ plantioMarker.porcentagemDeAreaPlantadaNoTalhao }}% {{ $t('areaTalhaoPlantada') }}
						</span>
					</div>
					<div
						v-if="Object.values(plantioMarker.infoPoligono).length"
						class="container__plantiomarker__open__info__poligono"
					>
						<PoligonoSvg :info-geo="plantioMarker.infoPoligono" />
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('totalVolume') }} </span>
						<span> {{ plantioMarker.volumeTotal?.toFixed(2) || 0 }} (m³/ha) </span>
					</div>
					<div class="container__plantiomarker__open__info__values right">
						<span>{{ $t('ima') }}</span>
						<span> {{ plantioMarker.incrementoMedioAnual?.toFixed(2) || 0 }} {{ $t('ano') }} </span>
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('plantationAge') }}</span>
						<span>
							{{ plantioMarker.idade }} {{ $t('anos') }}
							<template v-if="plantioMarker.idadeMeses > 0">
								{{ plantioMarker.idadeMeses }} {{ $t('meses') }}
							</template>
						</span>
					</div>
					<div class="container__plantiomarker__open__info__values right">
						<span>{{ $t('geneticMaterial') }}</span>
						<span> {{ plantioMarker.materialGenetico }}</span>
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div
						class="container__plantiomarker__open__info__values"
						style="width: 100%"
					>
						<span>{{ $t('usefulTrees') }} {{ plantioMarker.porcentagemDeArvoresUteis }}%</span>
						<div class="container__plantiomarker__open__info__progress">
							<div
								:style="{
									width: `${plantioMarker.porcentagemDeArvoresUteis}%`,
								}"
							/>
						</div>
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ plantioMarker.variavel.variavel }}</span>
						<span> {{ plantioMarker.variavel.media }}</span>
					</div>
				</div>
			</div>
		</div>
	</GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import PoligonoSvg from '../../../../../components/PoligonoSvg/PoligonoSvg'

export default {
	components: { GmapCustomMarker, PoligonoSvg },
	props: {
		/**
		 * Informacoes do marker e do plantio que devem ser colocados no mapa
		 */
		plantioMarker: Object,
	},
	data: () => {
		return {
			/**
			 * Define o zIndex do marker
			 */
			zIndex: 50,
		}
	},
}
</script>

<style scoped>
.container__plantiomarker {
	cursor: default;
	font-family: 'Open Sans', sans-serif;
	background-color: transparent;
}

.container__plantiomarker:hover {
	background-color: white;
	display: block;
	min-width: 20rem;
	border-radius: 10px;
	overflow: hidden;
	padding: 2rem 1.5rem;
	transition: background-color 0.5s ease-in-out;
}

@media (hover: hover) and (pointer: fine) {
	.container__plantiomarker:hover {
		transform: translateY(50%);
	}
}

.container__plantiomarker__close {
	color: white;
	font-size: 1rem;
	font-weight: 900;
	-webkit-text-stroke: 0.5px black;
	visibility: visible;
}

.container__plantiomarker:hover > .container__plantiomarker__close {
	visibility: hidden;
	width: 0;
	height: 0;
}

.container__plantiomarker__open {
	display: none;
	min-height: 0;
	min-width: 0;
}

.container__plantiomarker:hover .container__plantiomarker__open {
	display: flex;
	flex-direction: column;
	min-width: 20rem;
	animation: anima__plantiomarker__open 0.75s ease-in-out forwards;
}

@keyframes anima__plantiomarker__open {
	0%,
	10% {
		opacity: 0;
		transform: translateY(10px);
	}

	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.container__plantiomarker__open__title {
	display: flex;
	font-size: 1.5rem;
	font-weight: 700;
	color: rgb(var(--color-default));
	line-height: 1rem;
}

.container__plantiomarker__open__info {
	display: flex;
	justify-content: space-between;
}

.container__plantiomarker__open__info__values {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.container__plantiomarker__open__info__values.right {
	align-items: flex-end;
}

.container__plantiomarker__open__info__values > span:first-child {
	font-size: 0.75rem;
	color: var(--color-gray-dark);
	font-weight: 500;
}

.container__plantiomarker__open__info__values > span:nth-child(2) {
	font-size: 1.2rem;
	font-weight: 700;
}

.container__plantiomarker__open__info__values > span:nth-child(2) > span:first-child {
	font-size: 0.75rem;
	font-weight: 500;
}

.container__plantiomarker__open__info__values > span:nth-child(3) {
	background-color: rgba(var(--color-default), 0.2);
	color: rgb(var(--color-default));
	padding: 0 0.5rem;
	border-radius: 10px;
	font-weight: 600;
}

.container__plantiomarker__open__info__poligono {
	height: 5rem;
	width: 5rem;
}

.container__plantiomarker__open__info__progress {
	height: 5px;
	width: 100%;
	background-color: rgba(var(--color-rgb-gray), 0.3);
	border-radius: 25px;
	overflow: hidden;
}

.container__plantiomarker__open__info__progress > div {
	height: 5px;
	background-color: rgb(var(--color-default));
}
</style>
